/** Female portrait pool (Unsplash). Shuffled each visit; illustrative only, not matched to authors. */
const FEMALE_REVIEW_AVATARS = [
  'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=faces&auto=format&q=80',
  'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=faces&auto=format&q=80',
  'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=80&h=80&fit=crop&crop=faces&auto=format&q=80'
];

if (!customElements.get('product-reviews-slider')) {
  customElements.define(
    'product-reviews-slider',
    class ProductReviewsSlider extends HTMLElement {
      currentIndex = 0;
      slides = [];
      autoplayTimer = null;
      pauseHover = false;

      connectedCallback() {
        const jsonEl = document.getElementById(this.dataset.jsonId);
        if (!jsonEl) return;
        let pool;
        try {
          pool = JSON.parse(jsonEl.textContent);
        } catch (e) {
          return;
        }
        if (!Array.isArray(pool) || pool.length === 0) return;

        const pick = this.shufflePick(pool, Math.min(3, pool.length));
        const track = this.querySelector('.product-reviews-slider__track');
        const dotsWrap = this.querySelector('.product-reviews-slider__dots');
        if (!track || !dotsWrap) return;

        const avatarUrls = this.shufflePick(
          FEMALE_REVIEW_AVATARS,
          Math.min(pick.length, FEMALE_REVIEW_AVATARS.length)
        );

        track.innerHTML = '';
        dotsWrap.innerHTML = '';

        const viewport = this.querySelector('.product-reviews-slider__viewport');
        pick.forEach((item, i) => {
          const avatarSrc = avatarUrls[i] || FEMALE_REVIEW_AVATARS[0];
          const slide = document.createElement('div');
          slide.className = 'product-reviews-slider__slide';
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'slide');
          slide.setAttribute('aria-label', `${i + 1} / ${pick.length}`);
          slide.innerHTML = `
            <div class="product-reviews-slider__slide-inner">
              <div class="product-reviews-slider__avatar">
                <img src="${this.escapeAttr(avatarSrc)}" alt="" width="40" height="40" loading="${i === 0 ? 'eager' : 'lazy'}" decoding="async">
              </div>
              <div class="product-reviews-slider__body">
                <p class="product-reviews-slider__quote">${this.escapeHtml(item.quote)}</p>
                <div class="product-reviews-slider__meta">
                  <span class="product-reviews-slider__author">${this.escapeHtml(item.author)}</span>
                  <span class="product-reviews-slider__city">${this.escapeHtml(item.city)}</span>
                </div>
              </div>
            </div>`;
          track.appendChild(slide);

          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'product-reviews-slider__dot' + (i === 0 ? ' is-selected' : '');
          dot.setAttribute('aria-label', `Review ${i + 1}`);
          dot.addEventListener('click', () => this.goTo(i));
          dotsWrap.appendChild(dot);
        });

        const syncWidths = () => {
          if (!viewport) return;
          const w = viewport.getBoundingClientRect().width;
          track.style.width = `${w * pick.length}px`;
          Array.from(track.children).forEach((slide) => {
            slide.style.flex = `0 0 ${w}px`;
            slide.style.width = `${w}px`;
          });
          this.updateTransform();
        };
        syncWidths();
        this._onResize = () => {
          clearTimeout(this._resizeTimer);
          this._resizeTimer = setTimeout(syncWidths, 150);
        };
        window.addEventListener('resize', this._onResize);

        this.slides = pick;
        this.currentIndex = 0;
        this.startAutoplay();

        this.addEventListener('mouseenter', () => {
          this.pauseHover = true;
          this.stopAutoplay();
        });
        this.addEventListener('mouseleave', () => {
          this.pauseHover = false;
          this.startAutoplay();
        });
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => {
          if (!this.matches(':hover')) this.startAutoplay();
        });
      }

      shufflePick(arr, n) {
        const copy = [...arr].sort(() => Math.random() - 0.5);
        return copy.slice(0, n);
      }

      escapeHtml(s) {
        const d = document.createElement('div');
        d.textContent = s;
        return d.innerHTML;
      }

      escapeAttr(s) {
        return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
      }

      goTo(index) {
        const track = this.querySelector('.product-reviews-slider__track');
        const dots = this.querySelectorAll('.product-reviews-slider__dot');
        if (!track || !this.slides.length) return;
        const len = this.slides.length;
        this.currentIndex = ((index % len) + len) % len;
        this.updateTransform();
        dots.forEach((d, i) => d.classList.toggle('is-selected', i === this.currentIndex));
      }

      next() {
        this.goTo(this.currentIndex + 1);
      }

      updateTransform() {
        const track = this.querySelector('.product-reviews-slider__track');
        const viewport = this.querySelector('.product-reviews-slider__viewport');
        if (!track || !viewport) return;
        const slide = track.children[this.currentIndex];
        const offset = slide ? slide.offsetLeft : 0;
        track.style.transform = `translateX(-${offset}px)`;
      }

      startAutoplay() {
        this.stopAutoplay();
        const ms = parseInt(this.dataset.autoplayMs || '5000', 10);
        if (ms <= 0 || this.slides.length < 2) return;
        this.autoplayTimer = window.setInterval(() => {
          if (!this.pauseHover) this.next();
        }, ms);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this._onResize) window.removeEventListener('resize', this._onResize);
      }
    }
  );
}
